<h4 mat-dialog-title>
    {{ 'delete' | translate }} {{ data.member.email }} ?
</h4>
<div mat-dialog-content class="dialog-content-pad-15">
    <p class="content">{{ 'user_deletation_confirmation' | translate }}</p>
</div>
<div mat-dialog-actions>
    <button
            (click)="close()"
            class="btn btn-default"
            data-cy="cancel-btn">{{ 'cancel' | translate }}
    </button>
    <button
            (click)="close('disable')"
            class="btn btn-primary"
            data-cy="disable-btn">{{ 'disable_user' | translate }}
    </button>
    <button
            (click)="close('delete')"
            class="btn"
            data-cy="confirm-btn"
            ngClass="btn-danger">
        {{ 'delete' | translate }}
    </button>
</div>
